import api from "@/services/api";

export const adminService = {
    /**
     * Wipe all operational data for the current tenant.
     * Requires administrator password AND the confirmation phrase "LIMPAR TUDO".
     * @param {{ password: string, confirmation: string }} payload
     * @returns {Promise<{ok:boolean, deleted:Record<string,number>, kept:Record<string,number>}>}
     */
    async wipeData(payload) {
        const { data } = await api.post("/admin/wipe-data", payload);
        return data;
    },
};
